// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { ResearchLinks } from "src/modules/my-research/jsx/research-links.jsx";
import { Tooltip } from "src/modules/tooltip/jsx/component.jsx";
import { makeDate } from "src/lib/utils.js";

// Stateful components

export class ResearchSection extends React.Component{

    //
    // Lifecycle 
    //
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            key_dates: []
        };

        // Binds
    }

    componentDidMount() {
        var this_component = this;
        var getmyresearch = squiz.fn.getStorage('getmyresearch', 'session', 'json');
        
        if (getmyresearch) {
            var research_data = getmyresearch['data'];
            if (research_data) {
                
                var key_dates = this_component.generateKeyDates(research_data);
                
                this_component.setState({
                    data: research_data,
                    key_dates: key_dates
                });
            }
        }
    }


    //
    // Functions
    //

    generateKeyDates(research_data) {
        
        // Some standard dates
        var key_dates = [
            {
                name: "commencedDate",
                friendly_name: "Commenced"
            },
            {
                name: "confirmationDate",
                friendly_name: "Confirmation date"
            },
            {
                name: "earlyCandidatureMilestone",
                friendly_name: "Early candidature milestone"
            },
            {
                name: "minSubmissionDate",
                friendly_name: "Minimum submission date",
            },
            {
                name: "maxSubmissionDate",
                friendly_name: "Maximum submission date"
            }
        ];


        // Get date values from data
        key_dates.forEach(function(event, key) {
            var date = research_data[event['name']];
            event['date'] = new Date(date);
        });

        // Look for optional milestones
        var optional_dates = [];
        var milestones = research_data['milestones'];

        var milestone_descriptions = [
            "Thesis and Candidature Review",
            "Mid Candidature Report"
        ];
        
        if (milestones) {
            milestones.forEach(function(milestone, key) {
                var description = milestone['description'];
                var date_required = milestone['dateRequired'];

                if (milestone_descriptions.indexOf(description) > -1 && date_required) {
                    var date = new Date(date_required);
                    var friendly_description = description.replace(/^Thesis and Candidature Review$/, "Thesis and candidature review").replace(/^Mid Candidature Report$/, "Mid candidature report");
                    
                    optional_dates.push({
                        "friendly_name": friendly_description,
                        "date": date
                    });
                }
            });
        }
        
        // add optional dates to key dates arr
        if (optional_dates.length > 0) {
            key_dates = key_dates.concat(optional_dates);
        }

        var sorted_key_dates = key_dates.sort(function(a, b) {
            if (a['date'].getTime() > b['date'].getTime()) {
                return 1;
            }

            if (a['date'].getTime() < b['date'].getTime()) {
                return -1;
            }

            return 0;
        });

        return sorted_key_dates;
    }

    renderAcademicInfo() {
        var this_component = this;
        var data = this_component['state']['data'];

        if (data) {
            
            var organisation = data['organisation'] ? data['organisation'] : 'Unknown';
            var academic_load = data['load'] ? data['load'] : 'Unknown';

            var topic = 'Unknown';
            if (data['topic']) {
                // Replace HTML wrappers
                topic = data['topic'].replace(/<[^>]*>?/gm, '');

                // Replace special characters
                topic = {
                    '__html': topic
                };
            }

            var academic_arr = [
                {
                    key: "Academic organisation",
                    type: "text",
                    value: organisation
                },
                {
                    key: "Academic load",
                    type: "text",
                    value: academic_load
                },
                {
                    key: "Research topic",
                    type: "html",
                    value: topic
                } 
            ];

            var list_items = academic_arr.map(function(item, list_key) {
                var key = item['key'];
                var type = item['type'];
                var value = item['value'];

                return (
                    <li key={list_key} className="my-research-overview__item">
                        <h3 className="my-research-overview__item__title">{key}</h3>
                        {type === 'text' ? (
                            <div className="my-research-overview__item__info">{value}</div>
                        ) : (
                            <div className="my-research-overview__item__info" dangerouslySetInnerHTML={value}></div>
                        )}
                        
                    </li>
                );
            });

            
            return (
                <div className="my-research-overview__element my-research-overview__academic__element">
                    <h2 className="my-research-overview__element__title">
                        Academic
                    </h2>
                    <ul className="my-research-overview__list">
                        {list_items}
                    </ul>
                </div>
            );
        }

        return null;
    }

    renderKeyDates() {
        var this_component = this;
        var date_arr = this_component['state']['key_dates'];
        var date_format = 'DD/MM/YYYY';

        if (date_arr) {

            // Render date list
            var key_dates = date_arr.map(function(item, list_key) {
                var name = item['friendly_name'];
                var date = item['date'];
                var date_formatted = makeDate(date, date_format);
                var time = date.getTime();
                
                if (time > 0) {
                    
                    return (
                        <li key={list_key} className="my-research-overview__item">
                            <h3 className="my-research-overview__item__title">
                                {name}
                            </h3>
                            <div className="my-research-overview__item__info">
                                {date_formatted}
                            </div>
                        </li>
                    );
                }
                
            });

            // Render tooltip heading
            var tooltip = <h2>My key dates</h2>;
            var portal_context = this_component['context'];
            var user_personalisation = portal_context['user_personalisation'];
            var helpers = portal_context['helpers'];
            var current_page = portal_context['current_page'];
            var page_data = helpers.getPageBySlug(current_page);

            if (typeof page_data['content'] != 'undefined' && typeof page_data['content']['tooltips'] != 'undefined') {
                var tooltips = page_data['content']['tooltips'];
                var key_dates_tooltips = tooltips['key_dates'];
    
                if (key_dates_tooltips) {
                    var filtered_tooltips = sq_personalise.fn.filterItems(key_dates_tooltips, user_personalisation['attributes']);
    
                    if (filtered_tooltips.length > 0) {
                        var active_tooltip = filtered_tooltips[0];

                        var tooltip_content = {
                            'title': 'My key dates',
                            'info': active_tooltip['message'],
                            'button': {
                                'class': 'my-research-overview__element__title--btn',
                                'text': (<h2>My key dates</h2>)
                            }
                        };

                        tooltip = <Tooltip content={tooltip_content} />
                    }
                }
            }

            
            // Render key dates section
            return (
                <div className="my-research-overview__element my-research-overview__key-dates__element">
                    <div className="my-research-overview__element__title">
                        <div className="my-research-overview__element__title--container">
                            {tooltip}
                        </div>
                    </div>
                    <ul className="my-research-overview__list">
                        {key_dates}
                    </ul>
                </div>
            );
        }


        return null;
    }

    renderSupervisors() {
        var this_component = this;
        var data = this_component['state']['data'];

        if (data) {
            var convenors = data['convenors'];
            
            if (typeof(convenors) !== 'undefined' && convenors.length > 0) {

                var list_items = convenors.map(function(convenor, list_key) {
                    var name = convenor['name'];
                    var tooltip_content = {
                        'title': name,
                        'email': convenor['email'],
                        'info': convenor['role'],
                        'button': {
                            'class': 'my-research-overview__item__supervisor--name',
                            'text': name
                        }
                    };

                    return (
                        <li key={list_key} className="my-research-overview__item">
                            <div className="my-research-overview__supervisors__supervisor">
                                <h3 className="my-research-overview__item__title">{convenor['role']}</h3>
                                <Tooltip content={tooltip_content} />
                            </div>
                        </li>
                    );
                });
            }

            return (
                <div className="my-research-overview__element my-research-overview__supervisors__element">
                    <h2 className="my-research-overview__element__title">
                        Supervisors
                    </h2>
                    <ul className="my-research-overview__list">
                        {list_items}
                    </ul>
                </div>
            );
        }

        return null;
    }



    //
    // Render
    //

    render() {
        var this_component = this;
        var data = this_component['state']['data'];
        
        if (data) {
            return (
                <div className="my-research__section">
                    <div className="my-research-overview__wrapper">
                        {this_component.renderAcademicInfo()}
                        {this_component.renderKeyDates()}
                        {this_component.renderSupervisors()}
                    </div>
                    <ResearchLinks />
                </div>
            );
        }
        
        return null;
    }

};

ResearchSection.contextType = PortalContext;
